import React from 'react';

/**
 * Brand logo — single source of truth so every header, sidebar, and auth
 * screen renders the same mark. The image lives in
 * `public/images/logo/logo-no-text.png` (transparent PNG).
 *
 * Sizes match the spots where the logo is used:
 *   - xs  → 24px (inline chips, mobile nav)
 *   - sm  → 32px (default — top headers / navbars)
 *   - md  → 40px (dashboards, drawer headers)
 *   - lg  → 56px (auth pages)
 *   - xl  → 72px (hero / landing splash)
 */
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/logo/logo-no-text.png`;
export const BRAND_LOGO_FULL_SRC = `${process.env.PUBLIC_URL || ''}/images/logo/logo.png`;

const SIZE_CLASSES = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
  xl: 'w-[72px] h-[72px]',
};

const BrandLogo = ({ size = 'sm', className = '', alt = 'Snapsule' }) => {
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.sm;

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${sizeCls} ${className}`}
      aria-hidden={alt ? undefined : true}
    >
      <img
        src={BRAND_LOGO_SRC}
        alt={alt}
        className="h-full w-full object-contain"
        draggable={false}
      />
    </span>
  );
};

/** Two-tone wordmark: SNAP + blue SULE */
export const BrandWordmark = ({ className = '', size = 'md' }) => (
  <span
    className={`lp-brand-text lp-brand-text--${size} ${className}`.trim()}
    aria-label="Snapsule"
  >
    <span className="lp-brand-text-snap">SNAP</span>
    <span className="lp-brand-text-sule">SULE</span>
  </span>
);

export default BrandLogo;
